import styled from 'styled-components'
import { theme } from '../../theme/theme'

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.cardBackground};
  border-radius: ${theme.borderRadius.lg};
  padding: ${theme.spacing.lg};
  transition: ${theme.transitions.default};
  border: 1px solid ${({ theme }) => theme.colors.border};
`

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing.md};
`

export const CardTitle = styled.h3`
  color: ${({ theme }) => theme.colors.text};
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
`

export const CardContent = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};
`
